import {Button, Col, Container, Row} from "react-bootstrap";
import {ARRAY_MONTHS_FULL, dateToString} from "../../tools";
import {useAppSelector} from "../../hooks";
import {selectDepartment} from "../../../features/AppStateSlice";
import {useMemo} from "react";
import {filterEventsForADay, getEventClassColorName, getEventName} from "../shared";
import {LockIconButton} from "../../components/IconButtons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {RREventType} from "../../types/RREventType";
import useEventsForADay from "../useEventsForADay";
import {useWarehouseLocks, WarehouseLockNotice} from "../../warehouse/useWarehouseLocks";

type MDayEventsProps = {
    selectedDay: Date;
    onSelectedDayChange?: (day: Date) => void;
    onEventClick?: (event: RREventType) => void;
}

const MDayEvents: React.FC<MDayEventsProps> = ({ selectedDay, onSelectedDayChange, onEventClick }) => {
    const activeDepartment = useAppSelector(selectDepartment);
    const day = selectedDay.getDate();
    const month = ARRAY_MONTHS_FULL[selectedDay.getMonth()].toUpperCase();
    const selectedDayAsString = dateToString(selectedDay);
    const events = useEventsForADay(selectedDay);
    const warehouseStatus = useWarehouseLocks();

    return (
        <Container fluid={true} className={"p-2"}>
            <Row>
                <Col xs={"auto"} className={"pt-2"}>
                    <Button variant={"outline-dark"}
                            onClick={event => onSelectedDayChange && onSelectedDayChange(new Date(selectedDay.setDate(selectedDay.getDate() - 1)) )}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </Button>
                </Col>
                <Col className={"border shadow bg-white p-2 rounded"}>
                    <h1 className={"text-center"}>{day} {month}</h1>
                </Col>
                <Col xs={"auto"} className={"pt-2"}>
                    <Button variant={"outline-dark"}
                            onClick={event =>
                                onSelectedDayChange &&
                                onSelectedDayChange(new Date(selectedDay.setDate(selectedDay.getDate() + 1)) )}>
                        <FontAwesomeIcon icon={faArrowLeft} style={{transform: "scaleX(-1)"}} />
                    </Button>
                </Col>
            </Row>
            {
                events.length > 0 && events.map(
                    event =>
                        <Row key={event.id}
                             className={"border rounded mt-2 p-2 " + getEventClassColorName(event) }
                             onClick={() => onEventClick && onEventClick(event)}
                        >
                            <Col>
                                <div className={"mb-1 fw-bold"}>{getEventName(event, activeDepartment)}</div>
                                <WarehouseLockNotice access={warehouseStatus(selectedDay, event.id || "")}/>
                                {
                                    event.place && <div className={"small fst-italic mb-2"}>{event.place}</div>
                                }
                                <div>{
                                    [event.clientName, event.clientSpoc, event.clientPhone].filter(
                                        item => item !== ""
                                    ).join(", ")}
                                </div>
                            </Col>
                            {
                                (event.eventStatus === "WAREHOUSE" || event.id === "WAREHOUSE") &&
                                warehouseStatus(selectedDay).locked &&
                                <Col xs={"auto"}>
                                    <LockIconButton onClick={() => {}} />
                                </Col>
                            }
                            <Col xs={"auto"}>
                                <Button className={"btn-sm"} variant={"outline-dark"}
                                        onClick={() => onEventClick && onEventClick(event)}>
                                    <FontAwesomeIcon icon={faArrowLeft} style={{transform: "scaleX(-1)"}} />
                                </Button>
                            </Col>
                        </Row>
                )
            }
            {
                events.length === 0 &&
                <Row className={"border rounded mt-2 p-2"}>
                    <Col className={"text-center fs-3 fw-bold"}>
                        Няма събития за този ден
                    </Col>
                </Row>
            }
        </Container>
    );
};

export default MDayEvents;
